// @flow
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import api from '../../../lib/api';
import makeUrl from '../../../lib/makeUrl';
import endpoints from '../../../lib/endpoints';

import User from '../../User';

type Props = { data: Object };
type State = { trekData: Object | '' };

export default class GuidedTrekPurchaseItem extends Component<Props, State> {
  state = { trekData: null };

  async componentDidMount() {
    const trekId = this.props.data.item_data.id;

    try {
      const { data } = await api.get(endpoints.treks.overviewData(trekId));
      this.setState({ trekData: data });
    } catch (err) {
      console.log(err);
    }
  }

  formatDate(date) {
    return moment(date).format('D MMM YYYY');
  }

  render() {
    if (!this.state.trekData) return null;

    const { status, booking_status, currency = 'USD', amount } = this.props.data;
    const { name, region, id, start_date, author: guideId } = this.state.trekData;
    const trekLink = name && id && region && makeUrl.trekOverview(name, id, region);

    return (
      <div className="list-row">
        <div className="item date">{this.formatDate(start_date)}</div>

        <div className="item name">
          <i className="icon icon-hg-hiking" />{' '}
          <a href={trekLink}>
            <h5 style={{ display: 'inline' }}>{name ? name : ''}</h5>
          </a>
        </div>
        <div className="item price">
          {currency} {amount}
        </div>
        <div className="item price">{guideId && <GuideNameAndUrl id={guideId} />}</div>
        {booking_status === 'rejected' ? (
          <div className="item message error">Lodge owner rejected your booking.</div>
        ) : (
          <div className="item message error" />
        )}
        <div className="item cta">
          <div color="outline" size="sm" className={status === 'Pending' ? 'pending' : ''}>
            {status ? status : ''}
          </div>
        </div>
      </div>
    );
  }
}

const GuideNameAndUrl = ({ id }: string) => (
  <User userId={id}>
    {({ userData }) => {
      const { fullname, email_address } = userData;
      return (
        <p>
          <Link to={makeUrl.goToProfile(fullname, id)}>{fullname}</Link>
          <a href={`mailto:${email_address}`}>({email_address})</a>
        </p>
      );
    }}
  </User>
);



// WEBPACK FOOTER //
// ./src/components/Profile/PurchaseList/GuidedTrekPurchaseItem.jsx